import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { BlogHeroStyles } from './BlogListComponentStyles';

const BlogHero = () => {
  const router = useRouter();
  const [searchValue, setSearchValue] = useState(router.query.s || '');

  const search = () => {
    router.push(
      {
        pathname: '/blog',
        query: {
          s: searchValue,
        },
      },
      `/blog/?s=${searchValue.replace(/\s/g, '+')}`
    );
  };

  const onSearchChange = e => {
    const { currentTarget } = e;
    setSearchValue(currentTarget.value);
  };

  const onSearchKeyPress = ({ key }) => {
    if (searchValue !== '' && key === 'Enter') {
      search();
    }
  };

  return (
    <BlogHeroStyles className="hero">
      <div className="container">
        <h1 className="hero-title">{'Accounting, Bookkeeping & Tax Blog'}</h1>
        <div className="hero-subtitle">Your small business resource for accounting, bookkeeping, and taxes from our experts. </div>
        <div className="search-wrap">
          <div className="search-icon" />
          <input
            type="search"
            name="s"
            placeholder="Search our blog"
            autoComplete="off"
            className="search-input"
            value={searchValue}
            onChange={onSearchChange}
            onKeyDown={onSearchKeyPress}
          />
          <button className="btn btn--primary-clear" type="button" onClick={search}>
            Search
          </button>
        </div>
      </div>
    </BlogHeroStyles>
  );
};

export default BlogHero;
